/**
 * @generated SignedSource<<026b228758bb802834eb086365961b02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkspaceSignalEditScheduledArchiveAtSaveMutation$variables = {
  scheduledArchiveAt?: string | null;
  workspaceSignalId: string;
};
export type WorkspaceSignalEditScheduledArchiveAtSaveMutation$data = {
  readonly signalWorkspace: {
    readonly updateScheduledArchiveAt: {
      readonly id: string;
    };
  };
};
export type WorkspaceSignalEditScheduledArchiveAtSaveMutation = {
  response: WorkspaceSignalEditScheduledArchiveAtSaveMutation$data;
  variables: WorkspaceSignalEditScheduledArchiveAtSaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scheduledArchiveAt"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceSignalId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "workspaceSignalId"
      }
    ],
    "concreteType": "SignalWorkspaceMutation",
    "kind": "LinkedField",
    "name": "signalWorkspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "newArchiveAt",
            "variableName": "scheduledArchiveAt"
          }
        ],
        "concreteType": "SignalWorkspace",
        "kind": "LinkedField",
        "name": "updateScheduledArchiveAt",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceSignalEditScheduledArchiveAtSaveMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceSignalEditScheduledArchiveAtSaveMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "482986043517f39073c20174950c262b",
    "id": null,
    "metadata": {},
    "name": "WorkspaceSignalEditScheduledArchiveAtSaveMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceSignalEditScheduledArchiveAtSaveMutation(\n  $workspaceSignalId: ID!\n  $scheduledArchiveAt: String\n) {\n  signalWorkspace(id: $workspaceSignalId) {\n    updateScheduledArchiveAt(newArchiveAt: $scheduledArchiveAt) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "30f59a41118118599ac4aff70e16c0b1";

export default node;
